export const DUPLICATE_OF = 'duplicate_of'
export const TOPIC_ID = 'topic'
export const WORLD_ID = 'world_id'
export const SAT_TEST_ID = 'sat_test_id'
export const SERIES = 'series'
export const SESSION = 'session'
export const SESSION_FEEDBACK = 'sessionFeedback'
export const LEARNER_FEEDBACK = 'learnerFeedback'
export const USER_ID = 'user_id'
export const POST = 'p'
export const POST_FEEDBACK = 'postFeedback'
export const SESSION_BREAKOUT_ID = 'session_breakout_id'

export type QueryParams = Record<string, string | number | boolean>

export function queryParamsToString(queryParams: QueryParams | null | undefined): string {
  if (queryParams == null || Object.keys(queryParams).length === 0) {
    return ''
  }

  const urlParams = new URLSearchParams()

  Object.entries(queryParams).forEach(([key, value]) => {
    urlParams.set(key, `${value}`)
  })

  return `?${urlParams.toString()}`
}

export function getQueryParamArray(queryParam: string | string[] | null | undefined): string[] {
  return queryParam == null ? [] : typeof queryParam === 'string' ? [queryParam] : queryParam
}

export function addParams(url: string, params: Record<string, string>): string
export function addParams(url: URL, params: Record<string, string>): URL
export function addParams(url: string | URL, params: Record<string, string>): string | URL {
  const u = typeof url === 'string' ? new URL(url) : url
  Object.entries(params).forEach(([key, value]) => {
    u.searchParams.set(key, value)
  })
  if (typeof url === 'string') {
    return u.toString()
  }
  return u
}
